//Intent Mgt - Withdrawal & Deposit
export const ACTION_ENTRY = 'ENTRY';
export const ACTION_CANCEL = 'CANCELED';
export const ACTION_REJECT = 'REJECTED';
export const ACTION_RETURN = 'RETURNED';
export const ACTION_ACCEPT = 'ACCEPTED';
export const ACTION_SUCCESS = 'SUCCESS';
export const ACTION_COMPLETED = 'COMPLETED';
export const ACTION_PAID = 'PAID';
export const ACTION_ACCEPT_S1 = 'ACCEPT_S1';
export const ACTION_ACCEPT_S2 = 'ACCEPT_S2';

export const COMMERCIAL_BANK_SUBMIT = 'CB_SUBMIT';
export const COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION = 'CBS1_VERIFICATION';
export const COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION = 'CBS2_VERIFICATION';
export const SAFE_CUSTODY_VERIFICATION = 'SCC_VERIFICATION';
export const BACK_OFFICE_VERIFICATION = 'BT_VERIFICATION';
export const BACK_OFFICE_AUTHORIZATION = 'BT_AUTHORIZATION';// Notify scc,cb,generate bd forms
export const CBS_PAYMENT = 'CBS_PAYMENT';
export const BACK_OFFICE_PAY_AUTHORIZATION = 'BT_PAY_AUTHORIZATION';// Notify scc,cb,generate bd forms
export const SAFE_CUSTODY_DATE_CONFIRMATION = 'SCC_DT_CONFIRMATION';
export const SAFE_CUSTODY_BDFORM_SUBMIT = 'SCC_BDFORM_SUBMIT';
export const SAFE_CUSTODY_REP_WITHDRAWAL = 'SCC_REP_WITHDRAWAL';
export const SAFE_CUSTODY_SCC_WITHDRAWAL = 'SCC_CST_WITHDRAWAL';

export const BOT_VERIFIER_CONFIRMATION = 'BT_VERIFIER_CONFIRMED';
export const BOT_AUTHORIZER_CONFIRMATION = 'CBS_FEEDBACK';

export const SAFE_CUSTODY_REP_DEPOSIT = 'SCC_REP_DEPOSIT';
export const SAFE_CUSTODY_SCC_DEPOSIT = 'SCC_CST_DEPOSIT';

//Direct Banking
export const BOT_MANAGER_OP_APPROVAL = 'BT_MGR_APPROVAL';
export const BOT_AM_AUTHORIZATION = 'BT_AM_AUTHORIZATION';
export const BOT_TRX_COMMITED = 'CBS_FEEDBACK';

export const INTENT_COMPLETED = 'COMPLETED';


